import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppSpinnerService {

  appSpinner: boolean;

  constructor() { }

  show() {
    setTimeout(() => {
      this.appSpinner = true;
    }, 5);
  }

  hide() {
    setTimeout(() => {
      this.appSpinner = false;
    }, 5);
  }

}
